<template>
    <section class="container error-message-section" v-if="error">
        <div class="error-message-section__inner">
            <img src="/img/result/cross.svg" alt="" width="18" height="18">
            <p class="error-message">{{ error }}</p>
        </div>
    </section>
</template>
<style lang="scss" scoped>
    .error-message-section {
        padding: 0 20px;
    }

    .error-message {
        margin: 0;
        font-family: Inter, sans-serif;
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0;
    }

    .error-message-section__inner {
        display: flex;
        align-items: center;
        max-width: 848px;
        margin: 14px auto 0;
        padding: 13px 20px;
        text-align: center;
        gap: 20px;
        background: #EC0000;
        border-radius: 8px;
    }
</style>
<script>

export default {
    name: "ErrorMessage",
    data() {
        return {
            error: null
        }
    },
    created() {
        this.$root.$on('error-occured', (message) => {
            this.error = message;
        })
        this.$root.$on('clear-error', () => {
            this.error = null;
        })
    },
}
</script>
